  
function getCookieGlx(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

 function setCookieGlx(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
/*
  $.get("https://www.golflogix.com/GolfLogixAPIService.svc/GetLocation", function(data, status){
	var urls = 'https://greenbooks.com/pages/find-course-list/';
    //var urls = 'https://store.golflogix.com/collections/US_alaska?sort_by=title-ascending';

    if(status == 'success'){ 
      
      var CurrentLocation = JSON.parse(data);

      if( (CurrentLocation.CountryCode =='US' || CurrentLocation.CountryCode =='CA' ) && CurrentLocation.Region != ''){    
        var JsCntryCode = CurrentLocation.CountryCode;
        var JsState = (CurrentLocation.Region).toLowerCase();
        JsState = JsState.split(" ");
        JsState = JsState.join('-');
       var urls = 'https://greenbooks.com/collections/'+JsCntryCode+'_'+JsState+'\?sort_by=title-ascending';
       setCookieGlx('CoursesAvailable', urls, 3);
      //  var urls = 'https://greenbooks.com/pages/find-course-list/';
      }else {
          var urls = 'https://greenbooks.com/collections/US_arizona?sort_by=title-ascending';
         setCookieGlx('CoursesAvailable', urls, 3);
      }       
    }else {
       var urls = 'https://greenbooks.com/collections/US_arizona?sort_by=title-ascending';
      setCookieGlx('CoursesAvailable', urls, 3);
    }
   

  }); 
  */
   $.ajax({url: "https://www.golflogix.com/GolfLogixAPIService.svc/GetLocation",async:false, success: function(data){
    var CurrentLocation = JSON.parse(data);
      if( (CurrentLocation.CountryCode =='US' || CurrentLocation.CountryCode =='CA' ) && CurrentLocation.Region != ''){    
        var JsCntryCode = CurrentLocation.CountryCode;
        var JsState = (CurrentLocation.Region).toLowerCase();
        JsState = JsState.split(" ");
        JsState = JsState.join('-');
        
       var urls = 'https://greenbooks.com/pages/new-course-listing?';
       setCookieGlx('CoursesAvailable', urls, 3);
      //  var urls = 'https://greenbooks.com/pages/find-course-list/';
      }else {
          var urls = 'https://greenbooks.com/pages/new-course-listing?';
         setCookieGlx('CoursesAvailable', urls, 3);
      } 
  }});
  